{
  "v9.factures.abonnement.actif": "Active subscription",
  "v9.factures.abonnement.en_retard": "Subscription overdue",
  "v9.factures.abonnement.impaye": "Subscription unpaid",
  "v9.factures.abonnement.litige": "Dispute in progress",
  "v9.factures.abonnement.resilie": "Subscription cancelled",
  "v9.factures.annuler": "Cancel",
  "v9.factures.archive.bouton": "Download year {{annee}}",
  "v9.factures.archive.en_cours": "Preparing the archive…",
  "v9.factures.archive.erreur": "The archive could not be downloaded.",
  "v9.factures.archive.succes": "Archive downloaded.",
  "v9.factures.champ.annee": "Year",
  "v9.factures.champ.recherche": "Number or amount",
  "v9.factures.champ.statut": "Status",
  "v9.factures.code.ACCES_RESTREINT_IMPAYE": "Access restricted for unpaid invoices: settle the overdue invoices.",
  "v9.factures.code.CONFIRMATION_IDENTITE_REQUISE": "Confirm your identity (valid 5 minutes) before this action.",
  "v9.factures.code.CONTEXTE_INCOMPLET": "No organisation is attached to your session.",
  "v9.factures.code.CREANCE_DEJA_IRRECOUVRABLE": "This receivable is already uncollectible.",
  "v9.factures.code.DELAI_DE_REFLEXION_EN_COURS": "Self-approval: the cooling-off period has not elapsed.",
  "v9.factures.code.DEVISE_FIGEE": "The currency can no longer change after the first invoice: request a billing exception.",
  "v9.factures.code.DROIT_NON_TENU": "You do not hold the right this action requires.",
  "v9.factures.code.FACTURE_DEJA_REGLEE": "This invoice is already paid.",
  "v9.factures.code.IDEMPOTENCY_CONFLICT": "This payment was already submitted with another request: reload the page.",
  "v9.factures.code.NUMEROTATION_NON_MODIFIABLE": "The sequence can no longer change after the first invoice: only the prefix of future invoices can change.",
  "v9.factures.code.PAIEMENT_REFUSE": "The provider declined the payment: choose another payment method.",
  "v9.factures.code.PRESTATAIRE_INDISPONIBLE": "The payment provider cannot be reached: nothing was changed.",
  "v9.factures.code.PROPRIETAIRE_SEUL": "Reserved to the organisation owner.",
  "v9.factures.code.RESOURCE_UNAVAILABLE": "Item not found.",
  "v9.factures.code.SANS_SESSION": "Your session has expired: sign in again.",
  "v9.factures.code.STORAGE_UNAVAILABLE": "Document storage is unavailable: try again later.",
  "v9.factures.code.VALIDATION_ERROR": "Input refused: check the fields.",
  "v9.factures.code.VALIDATION_PAR_UN_TIERS": "Second signature required: another platform administrator validates the request.",
  "v9.factures.code.VERSION_CONFLICT": "This information changed in the meantime: reload the page before trying again.",
  "v9.factures.colonne.actions": "Actions",
  "v9.factures.colonne.emise_le": "Issued on",
  "v9.factures.colonne.etat": "Status",
  "v9.factures.colonne.montant": "Amount",
  "v9.factures.colonne.numero": "Number",
  "v9.factures.contester": "Dispute or request a credit note",
  "v9.factures.coordonnees.adresse": "Billing address",
  "v9.factures.coordonnees.adresse_invalide": "A recipient address is invalid.",
  "v9.factures.coordonnees.destinataires": "Invoice recipients (comma-separated)",
  "v9.factures.coordonnees.devise": "Currency",
  "v9.factures.coordonnees.devise_figee": "Currency fixed after the first invoice: change it through an exception request.",
  "v9.factures.coordonnees.enregistrees": "Billing details saved.",
  "v9.factures.coordonnees.erreur": "Billing details could not be saved.",
  "v9.factures.coordonnees.factures_futures": "Changes apply to future invoices only.",
  "v9.factures.coordonnees.fiscal_invalide": "Invalid tax identifier format.",
  "v9.factures.coordonnees.identifiant_fiscal": "Tax identifier",
  "v9.factures.coordonnees.pays": "Country (two-letter code)",
  "v9.factures.coordonnees.pays_invalide": "Two uppercase letters country code.",
  "v9.factures.coordonnees.raison_sociale": "Company name",
  "v9.factures.coordonnees.reference_commande": "Purchase order reference",
  "v9.factures.coordonnees.requis": "Required field.",
  "v9.factures.coordonnees.rien_a_enregistrer": "Nothing to save: no change.",
  "v9.factures.coordonnees.titre": "Billing details",
  "v9.factures.credit.titre": "Available credit",
  "v9.factures.credit.vide": "No available credit.",
  "v9.factures.demande.aucune": "No owner request.",
  "v9.factures.demande.instruire": "Review the request",
  "v9.factures.demande.refuser": "Refuse the request",
  "v9.factures.demande.titres": "Owner requests",
  "v9.factures.document.attestation_fiscale": "Tax certificate",
  "v9.factures.document.conditions_de_traitement_des_donnees": "Data processing terms",
  "v9.factures.document.conditions_en_vigueur": "Terms in force",
  "v9.factures.document.coordonnees_bancaires": "Bank details",
  "v9.factures.documents.erreur": "The document could not be downloaded.",
  "v9.factures.documents.fichier": "PDF file",
  "v9.factures.documents.fichier_requis": "Choose a file.",
  "v9.factures.documents.nature": "Document type",
  "v9.factures.documents.publie": "Version {{version}} published.",
  "v9.factures.documents.publier": "Publish a new version",
  "v9.factures.documents.telecharger": "Download",
  "v9.factures.documents.telecharger_nomme": "Download: {{nom}}",
  "v9.factures.documents.titre": "Platform documents",
  "v9.factures.documents.version": "version {{version}} of {{date}}",
  "v9.factures.documents.vide": "No document published.",
  "v9.factures.ecran.dialogue-enregistrer-un-reglement": "Record a received payment",
  "v9.factures.ecran.organisation-coordonnees-facturation": "Billing details",
  "v9.factures.ecran.organisation-facture-fiche": "Invoice",
  "v9.factures.ecran.organisation-factures": "Invoices and credit notes",
  "v9.factures.ecran.plateforme-facturation-indicateurs": "Billing indicators",
  "v9.factures.ecran.plateforme-litige-fiche": "Payment dispute",
  "v9.factures.ecran.plateforme-organisation-facturation": "Organisation billing",
  "v9.factures.ecran.plateforme-parametres-facturation": "Billing and tax settings",
  "v9.factures.effet_acces.acces_restreint": "Restricted access",
  "v9.factures.effet_acces.aucun": "None",
  "v9.factures.effet_acces.suspendu_pour_impaye": "Suspended for non-payment",
  "v9.factures.enregistrement": "Saving…",
  "v9.factures.enregistrer": "Save",
  "v9.factures.etat.chargement": "Loading: {{quoi}}…",
  "v9.factures.etat.erreur": "Could not read: {{quoi}}.",
  "v9.factures.etat.introuvable": "Not found: {{quoi}}.",
  "v9.factures.etat.refus": "Access denied.",
  "v9.factures.etat.vide": "Nothing to show.",
  "v9.factures.etat_facturation.a_jour": "Billing up to date.",
  "v9.factures.etat_facturation.acces_restreint": "Restricted access: read only.",
  "v9.factures.etat_facturation.delai_de_grace": "Grace period in progress.",
  "v9.factures.etat_facturation.suspendu_pour_impaye": "Organisation suspended for non-payment.",
  "v9.factures.etat_facture.avoir": "Credit note",
  "v9.factures.etat_facture.emise": "Issued",
  "v9.factures.etat_facture.en_retard": "Overdue",
  "v9.factures.etat_facture.impayee": "Unpaid",
  "v9.factures.etat_facture.irrecouvrable": "Uncollectible (still payable)",
  "v9.factures.etat_facture.partiellement_remboursee": "Partially refunded",
  "v9.factures.etat_facture.payee": "Paid",
  "v9.factures.etat_facture.remboursee": "Refunded",
  "v9.factures.exception.accorder": "Grant an exception",
  "v9.factures.exception.aucune": "No granted exception.",
  "v9.factures.exception.titres": "Granted exceptions",
  "v9.factures.exception.voir": "View exception",
  "v9.factures.fiche.actions": "Invoice actions",
  "v9.factures.fiche.aucune_imputation": "No credit applied to this invoice.",
  "v9.factures.fiche.avoir": "Credit note {{numero}}",
  "v9.factures.fiche.echeance": "Due date",
  "v9.factures.fiche.facture": "Invoice {{numero}}",
  "v9.factures.fiche.ht": "Total excl. tax",
  "v9.factures.fiche.imputation": "Credit applied: {{montant}} on {{date}}",
  "v9.factures.fiche.imputations": "Credit applied",
  "v9.factures.fiche.libelle": "Label",
  "v9.factures.fiche.lignes": "Invoice lines",
  "v9.factures.fiche.navigation": "Navigation",
  "v9.factures.fiche.reste_du": "Amount due",
  "v9.factures.fiche.taxes": "Taxes",
  "v9.factures.fiche.ttc": "Total incl. tax",
  "v9.factures.impaye.grace": "Grace period until {{date}}.",
  "v9.factures.impaye.lecture_seule": "Read-only access until {{date}}, then suspension for non-payment.",
  "v9.factures.impaye.titre": "Consequences of non-payment",
  "v9.factures.indicateurs.abonnes": "Subscribers per tier",
  "v9.factures.indicateurs.exceptions": "Granted exceptions",
  "v9.factures.indicateurs.impayes": "Unpaid by stage",
  "v9.factures.indicateurs.periode": "Period",
  "v9.factures.indicateurs.resiliations": "Cancellations and reasons",
  "v9.factures.indicateurs.revenus": "Recurring revenue per currency",
  "v9.factures.indicateurs.vide": "No data for this period.",
  "v9.factures.irrecouvrable.contresigner": "Countersign uncollectible status",
  "v9.factures.irrecouvrable.demande": "Request recorded: another administrator must countersign.",
  "v9.factures.irrecouvrable.demander": "Request uncollectible status",
  "v9.factures.irrecouvrable.erreur": "The uncollectible request did not succeed.",
  "v9.factures.irrecouvrable.irrecouvrable": "Receivable set to uncollectible.",
  "v9.factures.irrecouvrable.jeton": "Identity confirmation token (sole super administrator)",
  "v9.factures.irrecouvrable.motif": "Reason for uncollectible (at least 15 characters)",
  "v9.factures.irrecouvrable.motif_requis": "The reason must have at least {{min}} characters.",
  "v9.factures.irrecouvrable.reste_payable": "The receivable remains payable and follows the unpaid schedule.",
  "v9.factures.issue.accepte": "accepted",
  "v9.factures.issue.gagne": "won",
  "v9.factures.issue.ouvert": "open",
  "v9.factures.issue.perdu": "lost",
  "v9.factures.lien.adresse_invalide": "Enter a valid email address.",
  "v9.factures.lien.bouton": "Send the payment link",
  "v9.factures.lien.destinataire": "Email of the third party who will pay",
  "v9.factures.lien.en_cours": "Sending…",
  "v9.factures.lien.erreur": "The link could not be sent.",
  "v9.factures.lien.prestataire": "Pay on the provider page (mobile money)",
  "v9.factures.lien.sans_compte": "The third party pays on the provider page, without a DoIt account.",
  "v9.factures.lien.succes": "Link sent, valid until {{date}}.",
  "v9.factures.liste.aucun_resultat": "No invoice matches the search.",
  "v9.factures.liste.vide": "No invoice for this period.",
  "v9.factures.litige.aucun": "No dispute.",
  "v9.factures.litige.echeance": "Response deadline at the provider",
  "v9.factures.litige.effet": "Effect on access",
  "v9.factures.litige.facture": "Invoice",
  "v9.factures.litige.issue": "Outcome",
  "v9.factures.litige.lien": "Dispute of {{montant}} ({{issue}})",
  "v9.factures.litige.motif": "Reason",
  "v9.factures.litige.preuves": "Provide evidence at the provider",
  "v9.factures.litige.retour": "Back to organisation billing",
  "v9.factures.litige.titre": "Dispute {{reference}}",
  "v9.factures.litige.titres": "Disputes",
  "v9.factures.moyen.changer": "Change payment method",
  "v9.factures.parametres.calendrier": "Unpaid schedule",
  "v9.factures.parametres.calendrier_invalide": "Schedule days range from 0 to 365.",
  "v9.factures.parametres.emetteur": "Invoice issuer",
  "v9.factures.parametres.enregistres": "Settings saved.",
  "v9.factures.parametres.erreur": "Settings could not be saved.",
  "v9.factures.parametres.fiscalite": "Tax per country",
  "v9.factures.parametres.fiscalite_aide": "One rule per line: “SN 18 ttc”, “FR 20 ht autoliquidation”.",
  "v9.factures.parametres.fiscalite_invalide": "A tax rule is unreadable or its rate exceeds 100.",
  "v9.factures.parametres.grace": "Grace period (days)",
  "v9.factures.parametres.impayes_futurs": "A schedule change applies to future unpaid invoices only.",
  "v9.factures.parametres.lecture_seule": "Read-only (days)",
  "v9.factures.parametres.mentions": "Legal notices",
  "v9.factures.parametres.numerotation": "Numbering",
  "v9.factures.parametres.prefixe": "Prefix of future invoices",
  "v9.factures.parametres.prefixe_invalide": "Prefix: 1 to 20 characters A-Z, 0-9 or dash.",
  "v9.factures.parametres.reflexion": "Self-approval cooling-off period (hours, 1 to 168)",
  "v9.factures.parametres.reflexion_invalide": "The cooling-off period ranges from 1 to 168 hours.",
  "v9.factures.parametres.relances": "Reminders (days, comma-separated)",
  "v9.factures.parametres.retour": "Back to platform settings",
  "v9.factures.parametres.sequence": "Next sequence",
  "v9.factures.parametres.sequence_avant": "Editable until the first invoice; afterwards the sequence stays gapless.",
  "v9.factures.parametres.sequence_figee": "Sequence fixed since the first invoice: only the prefix changes.",
  "v9.factures.pdf.bouton": "Download PDF",
  "v9.factures.pdf.en_cours": "Downloading…",
  "v9.factures.pdf.erreur": "The PDF could not be downloaded.",
  "v9.factures.quoi.abonnement": "the subscription",
  "v9.factures.quoi.coordonnees": "billing details",
  "v9.factures.quoi.documents": "platform documents",
  "v9.factures.quoi.facture": "the invoice",
  "v9.factures.quoi.factures": "invoices",
  "v9.factures.quoi.litige": "the dispute",
  "v9.factures.quoi.parametres": "billing settings",
  "v9.factures.raison.exceptions_a_venir": "Exception requests: screen delivered by the exceptions package (v9-p04).",
  "v9.factures.raison.moyens_a_venir": "Payment methods: screen delivered by the subscription package (v9-p02).",
  "v9.factures.raison.parametres_a_venir": "Platform settings: screen delivered by wave V10c.",
  "v9.factures.raison.prestataire_a_venir": "Evidence upload awaits the real payment provider connection.",
  "v9.factures.reessayer": "Retry",
  "v9.factures.reglement.affectation": "Allocation to invoices",
  "v9.factures.reglement.affectation_invalide": "An allocation is not a valid amount.",
  "v9.factures.reglement.affectations_superieures": "Allocations exceed the amount received.",
  "v9.factures.reglement.affecter": "{{numero}} (due {{reste}})",
  "v9.factures.reglement.aucune_facture_due": "No invoice due: the whole amount goes to credit.",
  "v9.factures.reglement.erreur": "The payment could not be recorded.",
  "v9.factures.reglement.montant": "Amount received",
  "v9.factures.reglement.montant_invalide": "Enter a positive amount (two decimals at most).",
  "v9.factures.reglement.ouvrir": "Record a payment",
  "v9.factures.reglement.piece": "Supporting document (optional)",
  "v9.factures.reglement.recu": "Received payment",
  "v9.factures.reglement.recu_le": "Received on",
  "v9.factures.reglement.reference": "Reference (transfer, cheque…)",
  "v9.factures.reglement.reference_requise": "The reference is required.",
  "v9.factures.reglement.retour": "Back to organisation billing",
  "v9.factures.reglement.succes": "Payment recorded: due {{reste}}, credit created {{credit}}.",
  "v9.factures.reglement.trop_percu": "Any overpayment is added to the organisation credit.",
  "v9.factures.regler.bouton": "Pay now",
  "v9.factures.regler.en_cours": "Payment in progress…",
  "v9.factures.regler.erreur": "The payment could not be submitted.",
  "v9.factures.regler.etat.authentification_forte_requise": "Strong authentication requested by the provider.",
  "v9.factures.regler.etat.confirmation_attendue": "Payment submitted: awaiting provider confirmation.",
  "v9.factures.regler.etat.confirmee": "Payment confirmed.",
  "v9.factures.regler.etat.resultat_inconnu": "Unknown result: being checked with the provider, do not pay again.",
  "v9.factures.regler.etat.soumise": "Payment submitted to the provider.",
  "v9.factures.regler.retrouvee": "A payment for this invoice is already in progress: no second charge.",
  "v9.factures.retablissement.paiement_confirme_retablissement_en_cours": "Payment confirmed: access is being restored.",
  "v9.factures.retablissement.retabli": "Access restored.",
  "v9.factures.retour_abonnement": "Back to subscription",
  "v9.factures.retour_factures": "Back to invoices",
  "v9.factures.statut.avoirs": "Credit notes",
  "v9.factures.statut.impayees_et_en_retard": "Unpaid and overdue",
  "v9.factures.statut.payees": "Paid",
  "v9.factures.statut.remboursees": "Refunded",
  "v9.factures.statut.toutes": "All",
  "v9.factures.verification.invalide": "Invalid tax identifier.",
  "v9.factures.verification.non_verifie": "Tax identifier not verified.",
  "v9.factures.verification.non_verifie_taxe_appliquee": "Not verified: tax is applied.",
  "v9.factures.verification.verification_en_cours": "Verification in progress.",
  "v9.factures.verification.verifie": "Tax identifier verified.",
  "v9.factures.voir": "View",
  "v9.factures.voir_facture": "View invoice {{numero}}"
}
